import enUS from 'antd/lib/locale/en_US';
import zhCN from 'antd/lib/locale/zh_CN';
import zhHK from 'antd/lib/locale/zh_HK';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { isOverseas, isNative } from '@whelk/const/src/env';

import en from './locales/en.json';
import zh_Hans from './locales/zh-Hans.json';
import zh_Hant from './locales/zh-Hant.json';

export enum LOCALE_MAP {
  ZH_HANS = 'zh-Hans',
  ZH_HANT = 'zh-Hant',
  EN = 'en',
}
const ANTD_LOCALE_MAP: Record<LOCALE_MAP, any> = {
  [LOCALE_MAP.ZH_HANS]: zhCN,
  [LOCALE_MAP.ZH_HANT]: zhHK,
  [LOCALE_MAP.EN]: enUS,
};

export const I18N_NEXT_CONFIG_APP = {
  lng: LOCALE_MAP.ZH_HANS,
  fallbackLng: LOCALE_MAP.ZH_HANS,
  interpolation: {
    escapeValue: false, // 配置插值行为，例如是否转义值等
  },
  resources: {
    [LOCALE_MAP.EN]: {
      translation: en,
    },
    [LOCALE_MAP.ZH_HANT]: {
      translation: zh_Hant,
    },
    [LOCALE_MAP.ZH_HANS]: {
      translation: zh_Hans,
    },
  },
};

export const I18N_NEXT_CONFIG_EN = {
  lng: LOCALE_MAP.EN,
  fallbackLng: LOCALE_MAP.EN,
  interpolation: {
    escapeValue: false, // 配置插值行为，例如是否转义值等
  },
  resources: {
    en: {
      translation: en,
    },
  },
};

export const I18N_NEXT_CONFIG_ZH = {
  lng: LOCALE_MAP.ZH_HANS,
  fallbackLng: LOCALE_MAP.ZH_HANS,
  interpolation: {
    escapeValue: false, // 配置插值行为，例如是否转义值等
  },
  resources: {
    [LOCALE_MAP.ZH_HANS]: {
      translation: zh_Hans,
    },
  },
};

export function formatI18nString(template: string, ...values: (string | number)[]): string {
  let index = 0;
  return template.replace(/%s/g, () => {
    const value = values[index++];
    return typeof value === 'string' ? value : value.toString();
  });
}

// React 内使用的 i18n
if (isNative) {
  i18n.use(initReactI18next).init(I18N_NEXT_CONFIG_APP);
} else {
  i18n.use(initReactI18next).init(isOverseas ? I18N_NEXT_CONFIG_EN : I18N_NEXT_CONFIG_ZH);
}

export const getTextByLang = (key: string, lang: string): string => {
  const translated = i18n.t(key, { lng: lang });
  return translated;
};

export const getAntdLocale = (lang: string) => {
  return ANTD_LOCALE_MAP[lang as LOCALE_MAP];
};

export default i18n;
